export const localhostUrl = "http://localhost:8000/api/";
export const deployedUrl = "https://backend-live.card-console.com/api/";
export const stagingUrl = "https://backend-dev.card-console.com/api/";
export const stagingdevUrl = "https://backend-staging.card-console.com/api/";
export const testingUrl=    "https://backend.bestglobalpayments.app/api/";

let url = window.location.href;
 if (url.includes("localhost")) url = localhostUrl;
 if (url.includes("superadmin-dev")) url = stagingUrl;
 else if (url.includes("superadmin-staging")) url = stagingdevUrl;
 else if (url.includes("superadmin.card-console")) url = deployedUrl;
 else if (url.includes("bestglobalpayments")) url = testingUrl;
 else if (url.includes("bestglobalpayments")) url = testingUrl;
 else if (url.includes("bestglobalpayments")) url = testingUrl;
 else 
url=localhostUrl;

export const Env = {
  AuthApiUrl: url + "auth/",
  AccountApiUrl: url + "accounts/",
  UserApiUrl: url + "users/",
  UploadDocuments: url + "Upload/",
  ClientAdmin: url + "Client/",
  CardsApiUrl: url + "card/",
  CardHolderApiUrl: url + "cardholder/",
  ClaimRoleAuth: url + "ClaimRoleAuth/",
  DepositApiUrl: url + "deposits/",
  SettingsApiUrl: url + "settings/",
  HelpApiUrl: url + "help/",
  TransactionApiUrl: url + "transaction/",
  AutoFeeApiUrl: url + "autofee/",
  SuperClientApiUrl: url + "superclient/",
  IBANApiUrl: url + "IbanAccounts/",
  BankAccountApiUrl: url + "bankaccount/",
};
